<div class="prehox-paginator__inner" *ngIf="totalPages > 0 || !hidePageSize">
    <nav class="prehox-paginator__nav" *ngIf="totalPages > 0" aria-label="Paginação">
        <button
            type="button"
            class="prehox-paginator__btn prehox-paginator__btn--icon"
            *ngIf="showFirstLastButtons"
            [disabled]="disabled || !hasPreviousPage"
            (click)="firstPage()"
            aria-label="Primeira página"
        >
            <mat-icon svgIcon="heroicons_outline:chevron-double-left"></mat-icon>
        </button>

        <button
            type="button"
            class="prehox-paginator__btn prehox-paginator__btn--icon"
            [disabled]="disabled || !hasPreviousPage"
            (click)="previousPage()"
            aria-label="Página anterior"
        >
            <mat-icon svgIcon="heroicons_outline:chevron-left"></mat-icon>
        </button>

        <button
            type="button"
            class="prehox-paginator__btn prehox-paginator__btn--page"
            *ngFor="let page of visiblePages"
            [class.is-active]="page === pageIndex"
            [disabled]="disabled"
            (click)="goToPage(page)"
        >
            {{ page + 1 }}
        </button>

        <button
            type="button"
            class="prehox-paginator__btn prehox-paginator__btn--icon"
            [disabled]="disabled || !hasNextPage"
            (click)="nextPage()"
            aria-label="Próxima página"
        >
            <mat-icon svgIcon="heroicons_outline:chevron-right"></mat-icon>
        </button>

        <button
            type="button"
            class="prehox-paginator__btn prehox-paginator__btn--icon"
            *ngIf="showFirstLastButtons"
            [disabled]="disabled || !hasNextPage"
            (click)="lastPage()"
            aria-label="Última página"
        >
            <mat-icon svgIcon="heroicons_outline:chevron-double-right"></mat-icon>
        </button>
    </nav>

    <div class="prehox-paginator__page-size" *ngIf="!hidePageSize">
        <span class="prehox-paginator__page-size-label" autoTranslate>Itens por página</span>
        <select
            class="prehox-paginator__select"
            [disabled]="disabled"
            [value]="pageSize"
            (change)="onPageSizeChange($event)"
            aria-label="Itens por página"
        >
            <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
        </select>
    </div>
</div>
